export default __webpack_public_path__ + "static/media/element_54.be506bba.webp";